export default __webpack_public_path__ + "static/media/Indoor.31469669.png";